<template>
    <div class="container py-4">

        <!-- Contenido en 4 columnas -->
        <div class="row">
            <!-- Lo más visto -->
            <div class="col-lg-3 col-md-6 col-12 mb-3">
                <div class="stat-card">
                    <h5 class="stat-title">Lo más visto</h5>
                    <div class="row mt-3">
                        <div id="carousel-vistos" class="carousel carousel-dark slide carousel-fade"
                            data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-for="(item, index) in losmasvistosprods" :key="'vistos-' + index"
                                    class="carousel-item" :class="{ active: index === 0 }" data-bs-interval="2000">
                                    <cardprods :info="item" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Lo más buscado -->
            <div class="col-lg-3 col-md-6 col-12 mb-3">
                <div class="stat-card">
                    <h5 class="stat-title">Lo más buscado</h5>
                    <div class="row mt-3">
                        <div id="carousel-buscados" class="carousel carousel-dark slide carousel-fade"
                            data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-for="(item, index) in masbuscados" :key="'buscados-' + index"
                                    class="carousel-item" :class="{ active: index === 0 }" data-bs-interval="2000">
                                    <cardprods :info="item" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Últimos vendidos -->
            <div class="col-lg-3 col-md-6 col-12 mb-3">
                <div class="stat-card">
                    <h5 class="stat-title">Últimos vendidos</h5>
                    <div class="row mt-3">
                        <div id="carousel-vendidos" class="carousel carousel-dark slide carousel-fade"
                            data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-for="(item, index) in prodsultmasvend" :key="'vendidos-' + index"
                                    class="carousel-item" :class="{ active: index === 0 }" data-bs-interval="2000">
                                    <cardprods :info="item" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Más vendidos hoy -->
            <div class="col-lg-3 col-md-6 col-12 mb-3">
                <div class="stat-card">
                    <h5 class="stat-title">Más vendidos hoy</h5>
                    <div class="row mt-3">
                        <div id="carousel-hoy" class="carousel carousel-dark slide carousel-fade"
                            data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div v-for="(item, index) in prodsultmasvendhoy" :key="'hoy-' + index"
                                    class="carousel-item" :class="{ active: index === 0 }" data-bs-interval="2000">
                                    <cardprods :info="item" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import cardprods from "../../../Complements/Components/PresentacionProductos/cardsprods2.vue";
export default {
    name: "SearchCard",
    components: {
        cardprods
    },
    data() {
        return {
            losmasvistosprods: [],
            masbuscados: [],
            prodsultmasvend: [],
            prodsultmasvendhoy: [],
        };
    },
    methods: {
        async fetchDataVistos() {
            try {
                const veh = this.vehiculoSeleccionado;
                const { data } = await axios.get('/homedestacados/vistas');
                this.losmasvistosprods = Object.values(data);
            } catch (error) {
                console.error("Error cargando lo más visto:", error);
            }
        },
        async fetchDataBuscados() {
            try {
                const veh = this.vehiculoSeleccionado;
                const { data } = await axios.get('/homedestacados/masbuscados');
                this.masbuscados = Object.values(data);
            } catch (error) {
                console.error("Error cargando lo más buscado:", error);
            }
        },
        async fetchDataVendidos() {
            try {
                const veh = this.vehiculoSeleccionado;
                const { data } = await axios.get('/homedestacados/prodsultmasvend');
                this.prodsultmasvend = Object.values(data);
            } catch (error) {
                console.error("Error cargando últimos vendidos:", error);
            }
        },
        async fetchDataVendidosHoy() {
            try {
                const veh = this.vehiculoSeleccionado;
                const { data } = await axios.get('/homedestacados/prodsultmasvendhoy');
                this.prodsultmasvendhoy = Object.values(data);
            } catch (error) {
                console.error("Error cargando más vendidos hoy:", error);
            }
        },
    },
    mounted() {
        this.fetchDataVistos();
        this.fetchDataBuscados();
        this.fetchDataVendidos();
        this.fetchDataVendidosHoy();
    },
    computed: {
        vehiculoSeleccionado() {
            return this.$store.getters.vehiculoSeleccionado;
        }
    },
    watch: {
        vehiculoSeleccionado: {
            deep: true,
            handler() {
                this.fetchDataVistos();
                this.fetchDataBuscados();
                this.fetchDataVendidos();
                this.fetchDataVendidosHoy();
            }
        }
    }
};
</script>

<style scoped>
.search-wrapper {
    background: #fff;
    border-radius: 15px;
    margin: 20px auto;
}

/* Líneas decorativas */
.search-row {
    display: flex;
    align-items: center;
    justify-content: center;
}

.search-row .line {
    flex: 1;
    height: 2px;
    background: #06283c;
    margin: 0 10px;
    border-radius: 2px;
}

.search-row .search-label {
    font-weight: 600;
    color: #06283c;
    font-size: 1rem;
    text-transform: uppercase;
    letter-spacing: 1px;
}

/* Tarjetas */
.stat-card {
    border-radius: 12px;
    padding: 20px 10px;
    text-align: center;
    box-shadow: 0 4px 10px rgba(6, 40, 60, 0.1);
    transition: all 0.3s ease;
}

.stat-card:hover {
    background: #e9f4ff;
    transform: translateY(-4px);
    box-shadow: 0 6px 18px rgba(6, 40, 60, 0.15);
}

.stat-title {
    font-size: 1rem;
    color: #06283c;
    font-weight: 600;
}

/* Ajustes responsivos */
@media (max-width: 992px) {
    .stat-card {
        padding: 15px 10px;
    }
}

@media (max-width: 576px) {
    .search-row .search-label {
        font-size: 0.9rem;
    }
}
</style>